import { useState, useEffect, useContext } from 'react'
import { PatrimonioContext } from '../../../../contexts/patrimonioProvider'
import DataTable from '../../../Table';
import EditPatrimonioModal from './editModal';
import Movimenta from '../../Movimenta';
import { BiX } from "react-icons/bi";

const PatrimonioModal = ({ handleCloseModal, patrimonioType }) => {
    const { patrimonios } = useContext(PatrimonioContext);
    const [newPatrimonios, setNewPatrimonios] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [editModal, setEditModal] = useState(false);
    const [patrimonioSelecionado, setPatrimonioSelecionado] = useState({});
    const [movimentaModal, setMovimentaModal] = useState(false);
    const [selectedPatrimonios, setSelectedPatrimonios] = useState([]);

    useEffect(() => {
        let nPatrimonios = patrimonios ? [...patrimonios] : [];
        setNewPatrimonios(nPatrimonios);
    }, [patrimonios]);

    const editarPatrimonio = (id) => {
        setPatrimonioSelecionado(id);
        setEditModal(true);
    }

    const headers = [
        { 
            label: "Nº Patrimônio", 
            key: patrimonioType === 'novo' ? 'netiqueta' : 'nEtiqueta', 
            sortable: false,
            width: 'w-32',
            wrapText: false
        },
        { 
            label: "Equipamento", 
            key: patrimonioType === 'novo' ? "produto" : 'equipamento', 
            sortable: false,
            width: 'w-64',
            wrapText: true,
            truncate: true
        },
        { 
            label: "Nº Mac", 
            key: patrimonioType === 'novo' ? 'nmac' : 'nMac', 
            sortable: false,
            width: 'w-48',
            wrapText: false,
            truncate: true
        },
        { 
            label: "Nº Série", 
            key: patrimonioType === 'novo' ? 'nserie' : 'nSerie', 
            sortable: false,
            width: 'w-32',
            wrapText: false
        },
        { 
            label: "Cliente", 
            key: "nome_cliente", 
            sortable: false,
            width: 'w-64',
            wrapText: true,
            truncate: true
        },
        { 
            label: "Anexo", 
            key: "nome_anexo", 
            sortable: false,
            width: 'w-32',
            wrapText: false
        },
        { 
            label: "ID", 
            key: "id", 
            sortable: false,
            width: 'w-20',
            wrapText: false
        },
        { 
            label: "Ações", 
            key: "actions", 
            sortable: false, 
            actions: { "editar": editarPatrimonio },
            width: 'w-20',
            wrapText: false
        },
    ]

    const handleSelectionChange = (newSelectedItems) => {
        setSelectedItems(newSelectedItems);
    };

    const handleMovimentaModal = () => {
        let selectedPatrimonios = newPatrimonios.filter(patrimonio => selectedItems.includes(patrimonio.id));
        setSelectedPatrimonios(selectedPatrimonios);
        setMovimentaModal(true);
    }

    // Função de pesquisa customizada para patrimônios
    const customPatrimonioSearch = (item, searchTerm, headers) => {
        if (!searchTerm || searchTerm.trim() === '') {
            return true;
        }

        // Divide os termos de pesquisa por ponto e vírgula
        const searchTerms = searchTerm.split(' ').map(term => term.trim().toLowerCase()).filter(term => term !== '');
        
        // Se não há termos válidos, retorna todos os itens
        if (searchTerms.length === 0) {
            return true;
        }

        // Verifica se pelo menos um dos termos de pesquisa é encontrado
        return searchTerms.some(term => {
            return headers.some((header) => {
                const value = item[header.key];
                return (
                    typeof value === 'string' &&
                    value.toLowerCase().includes(term)
                );
            });
        });
    }

    return (
        <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2' onClick={(e) => e.target === e.currentTarget && handleCloseModal()}>
            <div className='bg-white dark:bg-gray-800 rounded-3xl shadow-vox-2xl max-w-[98vw] w-full mx-2 max-h-[98vh] overflow-hidden flex flex-col'>
				{/* Header */}
				<div className='bg-gradient-to-r from-vox-blue-600 to-vox-blue-800 px-6 py-6 relative'>
					<button 
						onClick={handleCloseModal} 
						className='absolute top-4 right-4 p-2 text-white hover:text-red-200 transition-colors duration-200 rounded-full hover:bg-white/20'
					>
						<BiX className='w-8 h-8' />
					</button>

					<div className='pr-16 flex items-center justify-between'>
						<h1 className='text-3xl font-bold text-white'>
							{selectedItems.length > 0 ? 'Patrimônios Selecionados' : 'Consulta de Patrimônios'}
						</h1>
						{selectedItems.length > 0 ? (
							<div className='flex items-center space-x-4'>
								<div className='bg-white/20 rounded-lg px-4 py-2'>
									<span className='text-2xl font-bold text-white'>{selectedItems.length}</span>
									<span className='text-white/80 ml-2'>selecionados</span>
								</div>
								<div className='bg-white/10 rounded-lg px-4 py-2'>
									<span className='text-lg font-medium text-white'>{newPatrimonios.length}</span>
									<span className='text-white/80 ml-2'>total</span>
								</div>
							</div>
						) : (
							<div className='flex items-center'>
								<div className='bg-white/20 rounded-lg px-4 py-2'>
									<span className='text-2xl font-bold text-white'>{newPatrimonios.length}</span>
									<span className='text-white/80 ml-2'>Patrimônios Totais Encontrados</span>
								</div>
							</div>
						)}
					</div>
				</div>

                {/* Content */}
                        <div className='flex-1 overflow-y-auto p-4'>
          {newPatrimonios && newPatrimonios.length > 0 ? (
            <DataTable 
              headers={headers} 
              data={newPatrimonios} 
              itemsPerPage={10} 
              checkboxColumn={true} 
              onSelectionChange={handleSelectionChange} 
              exportButton={true}
              docTitle={`Patrimônios - ${patrimonioType === 'novo' ? 'Novos' : 'Inventário'}`}
              customSearchFunction={customPatrimonioSearch}
            />
          ) : (
            <div className="flex flex-col items-center justify-center h-full text-gray-500 dark:text-gray-400">
              <div className="text-6xl mb-4">📦</div>
              <h3 className="text-xl font-semibold mb-2">Nenhum patrimônio encontrado</h3>
              <p className="text-sm">Tente ajustar os filtros de busca</p>
            </div>
          )}
        </div>

                {/* Footer */}
                <div className="p-4 border-t border-gray-200 dark:border-gray-700 flex justify-end space-x-4">
                    <button 
                        onClick={handleCloseModal}
                        className='px-6 py-2 bg-gray-500 hover:bg-gray-600 text-white font-medium rounded-lg transition-colors duration-200'
                    >
                        Fechar
                    </button>
                    {selectedItems.length > 0 && (
                        <button 
                            onClick={handleMovimentaModal}
                            data-tour-id='consulta:movimentar'
                            className='px-6 py-2 bg-gradient-to-r from-vox-blue-500 to-vox-blue-600 hover:from-vox-blue-600 hover:to-vox-blue-700 text-white font-medium rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200'
                        >
                            Movimentar ({selectedItems.length})
                        </button>
                    )}
                </div>

                {/* Modals */}
                {editModal && (
                    <EditPatrimonioModal 
                        setEditModal={setEditModal}
                        patrimonioSelecionado={patrimonioSelecionado}
                        setPatrimonioSelecionado={setPatrimonioSelecionado}
                        patrimonioType={patrimonioType}
                        patrimonios={newPatrimonios}
                    />
                )}
                {movimentaModal && (
                    <Movimenta 
                        selectedPatrimonios={selectedPatrimonios} 
                        setMovimentaModal={setMovimentaModal} 
                        setNewPatrimonios={setNewPatrimonios} 
                        newPatrimonios={newPatrimonios}
                        setSelectedPatrimonios={setSelectedPatrimonios}
                        patrimonioType={patrimonioType}
                    />
                )}
            </div>
        </div>
    )
}

export default PatrimonioModal
